import { combineReducers } from 'redux'
import allUsersReducer from './allUsersReducer'
import allTransactionsReducer from './allTransactions.slice'
import selectedTransactionsReducer from './selectedTransactionsReducer'
import financialAccountsReducer from './financialAccountsReducer'
import plaidItemReducer from './plaidItemReducer'
import transactionRulesReducer from './transactionRulesReducer'
import allUserCallEventsReducer from './allUserCallEventsReducer'
import allTransactionEditsReducer from './allTransactionEdits.slice'
import allAnnualTaxFilingsReducer from '@/features/admin/taxes/adminAnnualTaxFilings.slice'
import allRolesReducer from './allRolesReducer'
import allActionItemsReducer from '@/features/admin/action-items/allActionItems.slice'
import allActionItemCategoriesReducer from '@/features/admin/action-items/actionItemCategories.slice'
import allTooltipsReducer from '@/features/admin/action-items/allTooltips.slice'
import allFinancialAccountReconciliationsReducer from './allFinancialAccountReconciliationsReducer'
import allUserDocumentCategoriesReducer from '@/features/admin/user-document-categories/userDocumentCategories.slice'
import allZendeskBulkMessagesReducer from '@/features/admin/zendesk-bulk-messages/zendeskBulkMessage.slice'
import allTransactionChangeLogsReducer from '@/features/admin/transaction-change-logs/transactionChangeLog.slice'
import allHistoriesReducer from '@/features/admin/histories/histories.slice'
import allRecordSnapshotsReducer from '@/features/admin/record-snapshots/recordSnapshot.slice'
import allQAFeaturesReducer from '@/features/admin/qa/qaFeatures.slice'
import allQAUsersReducer from '@/features/admin/qa/qaUsers.slice'

export default combineReducers({
  allUsers: allUsersReducer,
  allTransactions: allTransactionsReducer,
  allTransactionEdits: allTransactionEditsReducer,
  selectedTransactions: selectedTransactionsReducer,
  financialAccounts: financialAccountsReducer,
  plaidItems: plaidItemReducer,
  transactionRules: transactionRulesReducer,
  allUserCallEvents: allUserCallEventsReducer,
  allRoles: allRolesReducer,
  allActionItems: allActionItemsReducer,
  allActionItemCategories: allActionItemCategoriesReducer,
  allTooltips: allTooltipsReducer,
  allFinancialAccountReconciliations: allFinancialAccountReconciliationsReducer,
  allUserDocumentCategories: allUserDocumentCategoriesReducer,
  allZendeskBulkMessages: allZendeskBulkMessagesReducer,
  allTransactionChangeLogs: allTransactionChangeLogsReducer,
  allHistories: allHistoriesReducer,
  allRecordSnapshots: allRecordSnapshotsReducer,
  allAnnualTaxFilings: allAnnualTaxFilingsReducer,
  allQAFeatures: allQAFeaturesReducer,
  allQAUsers: allQAUsersReducer,
})
